import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import NCZISetupModal from './NCZISetupModal';
import { AppContextProvider } from '../../../../Services/AppContext';
import { loadDOMComponent } from '../../../../helpers';
import { store } from '../../../../store/store';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';

loadDOMComponent({
	selector: 'react-nczi-setup',
	// @ts-ignore: TODO: needs typings
	callback: ({ container, context, props }) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<NCZISetupModal />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
